/* Verifica se a aplicação está sendo executada em localhost (IPv4, IPv6 ou hostname) */
const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' || // [::1] é o endereço IPv6 localhost
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/ // 127.0.0.1/8 é o localhost para IPv4
  )
);

/* Registra o service worker apenas em produção e quando o navegador der suporte */
export function register(config) {
  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);

    // se a PUBLIC_URL estiver em uma origem diferente, o service worker não funciona
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    window.addEventListener('load', () => {
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
      } else {
        // não é localhost, apenas registra o service worker
        registerValidSW(swUrl, config);
      }
    });
  }
};

/* Efetua o registro do service worker e trata os estados de atualização / instalação */
function registerValidSW(swUrl, config) {
  navigator.serviceWorker.register(swUrl).then(registration => {
    registration.onupdatefound = () => {
      const installingWorker = registration.installing;

      if (installingWorker == null) {
        return;
      }

      installingWorker.onstatechange = () => {
        if (installingWorker.state === 'installed') {
          if (navigator.serviceWorker.controller) {

            // executa o callback
            if (config && config.onUpdate) {
              config.onUpdate(registration);
            }
          } else {
            console.log('O conteúdo foi armazenado em cache para uso offline!');

            // executa o callback
            if (config && config.onSuccess) {
              config.onSuccess(registration);
            }
          }
        }
      };
    };
  }).catch(error => {
    console.error('Erro ao registrar o service worker:', error);
  });
};

/* Verifica se o service-worker.js existe */
function checkValidServiceWorker(swUrl, config) {
  // verifica se o serviceWorker foi encontrado, se não foi, recarrega a página
  fetch(swUrl).then(response => {
    // garante que o service worker existe e que realmente é um arquivo JS
    const contentType = response.headers.get('content-type');

    if (response.status === 404 || (contentType != null && contentType.indexOf('javascript') === -1)) {
      // nenhum service worker encontrado
      navigator.serviceWorker.ready.then(registration => {
        registration.unregister().then(() => {
          window.location.reload();
        });
      });
    } else {
      // service worker encontrado
      registerValidSW(swUrl, config);
    }
  }).catch(() => {
    console.log(
      'Nenhuma conexão com a internet encontrada. O app está sendo executado em modo offline!'
    );
  });
};

/* Remove o registro do service worker ativo */
export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
};